import { render, staticRenderFns, recyclableRender, components } from "./u-verification-code.vue?vue&type=template&id=38dd8f37&scoped=true&"
var renderjs
import script from "./u-verification-code.vue?vue&type=script&lang=js&"
export * from "./u-verification-code.vue?vue&type=script&lang=js&"
import style0 from "./u-verification-code.vue?vue&type=style&index=0&id=38dd8f37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd8f37",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-verification-code/u-verification-code.vue"
export default component.exports